import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import React, { useContext } from 'react';
import { ConfigContext } from '../config-provider';
import Icon from '../icon';

var Content = function Content(args) {
  var _context;

  var icon = args.icon,
      content = args.content,
      closable = args.closable,
      suffixCls = args.suffixCls,
      type = args.type,
      contentClose = args.contentClose,
      closeNode = args.closeNode;

  var _useContext = useContext(ConfigContext),
      prefixCls = _useContext.prefixCls;

  var classPrefix = _concatInstanceProperty(_context = "".concat(prefixCls, "-")).call(_context, suffixCls, "-content");

  var iconMap = {
    success: /*#__PURE__*/React.createElement(Icon, {
      type: "right-solid"
    }),
    warning: /*#__PURE__*/React.createElement(Icon, {
      type: "warning-solid"
    }),
    error: /*#__PURE__*/React.createElement(Icon, {
      type: "warning-solid"
    }),
    info: /*#__PURE__*/React.createElement(Icon, {
      type: "notice"
    })
  };

  var renderIcon = function renderIcon() {
    if (icon) return /*#__PURE__*/React.createElement("div", {
      className: "".concat(classPrefix, "-icon-wrapper")
    }, icon);
    return iconMap[type] ? /*#__PURE__*/React.createElement("div", {
      className: "".concat(classPrefix, "-icon-wrapper")
    }, iconMap[type]) : null;
  };

  var handleClick = function handleClick(e) {
    if (e) {
      e.stopPropagation();
    }

    contentClose && contentClose();
  };

  var renderCloseIcon = function renderCloseIcon() {
    if (!closable) return null;

    if (closeNode) {
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(classPrefix, "-close"),
        onClick: handleClick
      }, closeNode);
    }

    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(classPrefix, "-close"),
      onClick: handleClick
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "close"
    }));
  };

  var getMainElement = function getMainElement() {
    if (typeof content === 'string') {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "".concat(classPrefix, "-main")
      }, renderIcon(), /*#__PURE__*/React.createElement("div", {
        className: "".concat(classPrefix, "-text")
      }, content)), renderCloseIcon());
    }

    if ( /*#__PURE__*/React.isValidElement(content)) {
      return content;
    }

    return null;
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, getMainElement());
};

export default Content;